<div class="scrollable-container">
  <app-header></app-header>
  <div class="container-xxl container-fluid custom-margin">
    <div class="row">
      @if(showSidebar | async){
      <div class="col-lg-3 col-12">
        <app-vertical-menu cy-dashboard-menu class="menu-styles">
        </app-vertical-menu>
      </div>
      }

      <div class="col-lg-9 col-12">
        <div class="main-content p-3">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>